/**
 * voiceBackground.js
 * ─────────────────────────────────────────────────────────────────────────
 * Mapeia voice_id → URL de imagem artística no R2 (CDN). Hash determinístico:
 * a MESMA voz sempre pega a MESMA imagem (sem flicker, idempotente entre sessões).
 *
 * 126 imagens disponíveis em https://cdn.darkplanner.com.br/voice-bg/bg-001.webp
 * até bg-126.webp. Cada uma ~5-10 KB, lazy-loaded pelo browser quando o avatar
 * entra no viewport.
 *
 * Fallback: se a imagem falhar de carregar (rede, CDN, miss), o componente
 * VoiceAvatar volta pro estilo antigo (esfera 3D com inicial colorida).
 */

const CDN_BASE = 'https://cdn.darkplanner.com.br/voice-bg';
const TOTAL_IMAGES = 126;

/**
 * Hash determinístico (variante djb2) de string → inteiro positivo.
 * Mesma entrada sempre retorna o mesmo número.
 */
function hashString(str) {
  let hash = 5381;
  const s = String(str || '');
  for (let i = 0; i < s.length; i++) {
    hash = ((hash << 5) + hash) + s.charCodeAt(i);
    hash = hash & hash; // força int32
  }
  return Math.abs(hash);
}

/**
 * Retorna URL de background determinística pra um voice_id.
 *
 * @param {string|null|undefined} voiceId  ID único da voz (voice.id UUID Carlos
 *                                          ou voice.voice_info.voice_id ElevenLabs)
 * @returns {string}                       URL HTTPS da imagem no CDN
 */
export function getVoiceBackground(voiceId) {
  if (!voiceId) {
    // Fallback estável pra vozes sem ID (caso raro)
    return `${CDN_BASE}/bg-001.webp`;
  }
  const hash = hashString(voiceId);
  const index = (hash % TOTAL_IMAGES) + 1; // 1..126 inclusive
  const padded = String(index).padStart(3, '0');
  return `${CDN_BASE}/bg-${padded}.webp`;
}

export const VOICE_BG_TOTAL = TOTAL_IMAGES;
export const VOICE_BG_CDN = CDN_BASE;
